import * as React from 'react';

// Equivalent de React.useState dont la valeur est conservee dans
// sessionStorage : elle survit a la navigation entre pages et au
// rechargement, le temps de l'onglet. La valeur doit etre serialisable en JSON.
export function useEtatSession<T>(cle: string, initiale: T): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [valeur, setValeur] = React.useState<T>(() => {
    try {
      const brut = sessionStorage.getItem(cle);
      return brut === null ? initiale : (JSON.parse(brut) as T);
    } catch {
      return initiale;
    }
  });

  React.useEffect(() => {
    try {
      sessionStorage.setItem(cle, JSON.stringify(valeur));
    } catch {
      // Stockage indisponible (navigation privee, quota) : etat en memoire seulement.
    }
  }, [cle, valeur]);

  return [valeur, setValeur];
}
